import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import Button from '@/components-latest/primitives/Button'
import {
  Drawer,
  DrawerBody,
  DrawerClose,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerTrigger
} from '@/components-latest/primitives/Drawer'
import { ArrowLeft } from '@/components-latest/primitives/Icons'
import ScrollArea from '@/components-latest/primitives/Scrollable'
import Text from '@/components-latest/primitives/Text'

import Styles from './FiltersDrawer.module.scss'

interface IFiltersDrawerProps {
  children: React.ReactNode
  onReset: () => void
  onSubmit: () => void
  trigger: React.ReactNode
  disabled: boolean
  disableReset?: boolean
  onOpenChange: (isOpen: boolean) => void
}

const FiltersDrawer: React.FC<IFiltersDrawerProps> = ({
  children,
  trigger,
  onReset,
  onSubmit,
  disabled,
  onOpenChange,
  disableReset = false
}) => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)

  return (
    <Drawer
      dismissible={false}
      open={open}
      onOpenChange={isOpen => {
        setOpen(isOpen)
        onOpenChange(isOpen)
      }}>
      <DrawerTrigger asChild>{trigger}</DrawerTrigger>
      <DrawerContent className={Styles.drawer} data-testid="filters-drawer">
        <DrawerHeader className={Styles.header}>
          <DrawerClose className={Styles.closeTrigger}>
            <ArrowLeft />
          </DrawerClose>
          <Text variant="nextTitle-2" className={Styles.title}>
            {t('common.filters')}
          </Text>
          <Button
            variant="tertiary"
            size="small"
            onClick={() => {
              onReset()
              setOpen(false)
            }}
            disabled={disableReset}>
            {t('common.cta.reset')}
          </Button>
        </DrawerHeader>
        <ScrollArea>
          <DrawerBody className={Styles.body} data-vaul-no-drag>
            {children}
          </DrawerBody>
        </ScrollArea>
        <DrawerFooter className={Styles.footer}>
          <Button
            variant="primary"
            size="large"
            onClick={() => {
              onSubmit()
              setOpen(false)
            }}
            disabled={disabled}>
            {t('common.cta.apply')}
          </Button>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  )
}

export default FiltersDrawer
